/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import store from '@/store/index.js';
import { paymentReview } from '@/api/ajax.js';
import { PAY_STATUS2 } from '@/common/constants/order';

const getFeeTypes = () =>
  new Promise(resolve => {
    const data = {
      data: store.state.user.enums['costType'],
      message: '',
      code: '1',
      status: '1'
    };
    resolve({ data });
  });

const shortcuts = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      picker.$emit('pick', [start, end]);
    }
  },
  {
    text: '昨天',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);
      picker.$emit('pick', [start, end]);
    }
  },
  {
    text: '最近一周',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    }
  },
  {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    }
  },
  {
    text: '最近半年',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
      picker.$emit('pick', [start, end]);
    }
  }
];

export default [
  {
    width: 180,
    tip: '订单编号',
    label: '订单编号',
    key: 'orderNo',
    id: 'orderNo',
    slot: 'input',
    maxLength: 100
  },
  {
    width: 180,
    tip: '批次编号',
    label: '批次编号',
    key: 'batchOrderNo',
    id: 'batchOrderNo',
    slot: 'input',
    maxLength: 100
  },
  {
    width: 180,
    tip: '项目名称',
    label: '项目名称',
    key: 'projectId',
    id: 'projectId',
    slot: 'input'
  },
  {
    width: 180,
    tip: '项目名称',
    label: '项目名称',
    key: 'projectName',
    id: 'projectName',
    slot: 'input'
  },
  {
    width: 180,
    tip: '备注',
    label: '备注',
    key: 'platformRemark',
    id: 'remark',
    slot: 'input'
  },
  {
    width: 180,
    tip: '工业',
    label: '工业',
    key: 'platformRemark',
    id: 'industrial',
    slot: 'input'
  },
  {
    width: 180,
    tip: '工业',
    label: '工业',
    key: 'industryName',
    id: 'industrialReal',
    slot: 'input'
  },
  {
    id: 'dingdanshengchengshijian',
    width: 180,
    tip: '订单生成时间',
    label: '订单生成时间',
    key: 'createDate',
    slot: 'daterange',
    type: 'daterange'
  },
  {
    id: 'zhifujiezhishijian',
    width: 180,
    tip: '支付截止时间',
    label: '支付截止时间',
    key: 'payDate',
    slot: 'daterange',
    type: 'daterange'
  },
  {
    id: 'wanchengshijian',
    width: 180,
    tip: '完成时间',
    label: '完成时间',
    key: 'finishPay',
    slot: 'daterange',
    type: 'daterange'
  },
  {
    id: 'tiJiaoAudit',
    width: 180,
    tip: '提交审核时间',
    label: '提交审核时间',
    key: ['startTime', 'endTime'],
    slot: 'daterange',
    type: 'daterange',
    pickerOptions: {
      shortcuts: shortcuts
    }
  },
  {
    id: 'aspAuditDt',
    width: 180,
    tip: '审核时间',
    label: '审核时间',
    key: ['startTime', 'endTime'],
    slot: 'daterange',
    type: 'daterange',
    pickerOptions: {
      shortcuts: shortcuts
    }
  },
  {
    width: 180,
    id: 'paymentState',
    key: 'payStatus',
    tip: '支付状态',
    label: '支付状态',
    required: false,
    slot: 'select',
    clearable: true,
    options: [
      { name: '支付中', key: 1 },
      { name: '支付失败', key: 4 },
      { name: '支付成功', key: 3 },
      { name: '部分支付成功', key: 2 }
    ]
  },
  {
    width: 180,
    id: 'paymentStat',
    key: 'payStatus',
    tip: '支付状态',
    label: '支付状态',
    required: false,
    slot: 'select',
    clearable: true,
    options: [
      { name: '待支付', key: 0 },
      { name: '支付中', key: 1 },
      { name: '部分支付成功', key: 2 },
      // { name: '支付成功', key: 3 },
      { name: '支付失败', key: 4 },
      { name: '无法支付', key: 5 }
    ]
  },
  {
    width: 180,
    id: 'aspAuditStatusSelect',
    key: 'aspAuditStatus',
    tip: '审核状态',
    label: '审核状态',
    required: false,
    slot: 'select',
    clearable: true,
    options: [
      { name: '审核通过', key: 2 },
      { name: '审核不通过', key: 3 }
    ]
  },
  // {
  //   width: 180,
  //   id: 'feeType',
  //   key: 'costType',
  //   tip: '费用类型',
  //   label: '费用类型',
  //   required: false,
  //   slot: 'select',
  //   clearable: true,
  //   options: getStorage('enums')['costType']
  // }
  {
    id: 'feeType',
    key: 'costType',
    tip: '费用类型',
    label: '费用类型',
    required: false,
    slot: 'ajaxSelect',
    ajax: getFeeTypes,
    prop: {
      label: 'name',
      code: 'key'
    },
    ajaxQuery: 'projectName',
    width: 'auto'
  },
  {
    width: 180,
    label: '项目名称',
    tip: '请输入关键字',
    key: 'projectId',
    id: 'projectNameSelect',
    slot: 'ajaxSelect',
    clearable: true,
    ajax: async data => {
      try {
        const res = await paymentReview.listProjectName(data);
        return res;
      } catch (error) {
        return error;
      }
    },
    prop: {
      label: 'projectName',
      code: 'id'
    },
    ajaxQuery: 'projectName'
  },
  {
    width: 180,
    label: '企业名称',
    tip: '请输入关键字',
    key: 'industryId',
    id: 'industryIdSelect',
    slot: 'ajaxSelect',
    clearable: true,
    ajax: async data => {
      try {
        const res = await paymentReview.listEnterpriseName({
          ...data,
          enterpriseType: 1
        });
        return res;
      } catch (error) {
        return error;
      }
    },
    prop: {
      label: 'enterpriseName',
      code: 'id'
    },
    ajaxQuery: 'enterpriseName'
  },
  {
    width: 180,
    label: '供应商',
    tip: '请输入关键字',
    key: 'supplierId',
    id: 'supplierIdSelect',
    slot: 'ajaxSelect',
    clearable: true,
    ajax: async data => {
      try {
        const res = await paymentReview.listEnterpriseName({
          ...data,
          enterpriseType: 3
        });
        return res;
      } catch (error) {
        return error;
      }
    },
    prop: {
      label: 'enterpriseName',
      code: 'id'
    },
    ajaxQuery: 'enterpriseName'
  },
  {
    id: 'payStatusCascader',
    tip: '支付状态',
    label: '支付状态',
    key: ['payStatus', 'isComplete'],
    attrs: {
      placeholder: '支付状态',
      clearable: true,
      props: {
        checkStrictly: true
      },
      options: Object.values(PAY_STATUS2)
    },
    slot: 'cascader'
  },
  {
    width: 180,
    id: 'isComplete',
    key: 'isComplete',
    tip: '完结状态',
    label: '完结状态',
    required: false,
    slot: 'select',
    clearable: true,
    options: [
      { name: '全部', key: 0 },
      { name: '手动完结', key: 1 },
      { name: '正常完结', key: 2 }
    ]
  }
];
